import React from "react";
export var CheckIcon = function (_a) {
    var _b = _a.color, color = _b === void 0 ? "#CBD5E0" : _b, _c = _a.isChecked, isChecked = _c === void 0 ? false : _c, _d = _a.size, size = _d === void 0 ? 24 : _d;
    return (React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("circle", { cx: "12", cy: "12", r: "11.3", stroke: color, strokeWidth: "1.4" }),
        isChecked && (React.createElement("path", { d: "M17.1434 8.57227L10.6613 15.4294L7.71484 12.3125", stroke: color, strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }))));
};
